import React, { useRef } from 'react';
import { experiences } from '../../data/mock';
import { SectionEyebrow, SectionTitle, SectionLead, GhostLink, Reveal } from './UI';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { IMAGE_SIZES, responsiveImageProps } from '../../lib/images';

const ExperienceSlider = () => {
  const scrollerRef = useRef(null);

  const scrollBy = (dir) => {
    const el = scrollerRef.current;
    if (!el) return;
    const card = el.querySelector('[data-card]');
    const step = card ? card.getBoundingClientRect().width + 24 : el.clientWidth * 0.8;
    el.scrollBy({ left: dir * step, behavior: 'smooth' });
  };

  return (
    <section id="experiences" className="bg-[#f6f3ee]">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 pt-20 md:pt-32 pb-10 md:pb-14">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <Reveal>
              <SectionEyebrow>Special Experiences</SectionEyebrow>
              <SectionTitle className="mt-6">Moments shaped for the modern traveller.</SectionTitle>
            </Reveal>
          </div>
          <div className="max-w-md">
            <Reveal>
              <SectionLead>
                From a chef’s table on the strait to a fourth night on us — curated offers that reveal Istanbul at its most poetic.
              </SectionLead>
            </Reveal>
          </div>
        </div>

        <div className="mt-10 md:mt-14 flex items-center justify-between">
          <GhostLink href="#stay">View All Offers</GhostLink>
          <div className="hidden md:flex gap-2">
            <button onClick={() => scrollBy(-1)} aria-label="Previous" className="w-11 h-11 border border-neutral-300 flex items-center justify-center hover:bg-neutral-900 hover:text-white transition-colors">
              <ArrowLeft className="w-4 h-4" strokeWidth={1.25} />
            </button>
            <button onClick={() => scrollBy(1)} aria-label="Next" className="w-11 h-11 border border-neutral-300 flex items-center justify-center hover:bg-neutral-900 hover:text-white transition-colors">
              <ArrowRight className="w-4 h-4" strokeWidth={1.25} />
            </button>
          </div>
        </div>
      </div>

      <div className="pb-24 md:pb-32">
        <div
          ref={scrollerRef}
          className="flex gap-6 overflow-x-auto snap-x snap-mandatory scroll-smooth px-5 md:px-10 no-scrollbar"
        >
          {experiences.map((exp) => (
            <article
              key={exp.id}
              data-card
              className="snap-start shrink-0 w-[82vw] sm:w-[60vw] md:w-[520px] lg:w-[560px]"
            >
              <div className="relative overflow-hidden group aspect-[4/5]">
                <img
                  {...responsiveImageProps(exp.image, IMAGE_SIZES.sliderCard)}
                  alt={exp.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform [transition-duration:1600ms] ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent" />
                <div className="absolute top-6 left-6 tracking-[0.28em] text-[10.5px] uppercase text-white/90">
                  {exp.tag}
                </div>
                <div className="absolute bottom-6 left-6 right-6 text-white">
                  <div className="font-serif text-2xl md:text-3xl leading-tight">{exp.title}</div>
                  <p className="mt-3 text-white/85 font-light line-clamp-3">{exp.desc}</p>
                  <div className="mt-5">
                    <span className="inline-flex items-center gap-3 tracking-[0.22em] text-[11px] uppercase">
                      <span className="inline-block w-7 h-px bg-white" />
                      Discover
                    </span>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExperienceSlider;
